import moment from "moment-timezone"

export const formatDate = (s: string) => {
  return moment(s).tz("Asia/Tokyo").format("YYYY.MM.DD")
}

export const formatISO = (s: string) => {
  return moment(s).tz("Asia/Tokyo").format()
}

export const compareDate = (
  a: string,
  b: string,
  opt: { reverse: boolean } = { reverse: true }
) => {
  const am = moment(a).tz("Asia/Tokyo")
  const bm = moment(b).tz("Asia/Tokyo")
  if (am.isAfter(bm)) {
    return opt.reverse ? -1 : 1
  }
  if (am.isBefore(bm)) {
    return opt.reverse ? 1 : -1
  }
  return 0
}
